window.odTheme = window.odTheme || {};

window.odTheme.RenewalPromotion = (function() {
  
  function RenewalPromotion(cart){
    this.update(cart);
  }

  RenewalPromotion.prototype = $.extend({}, RenewalPromotion.prototype, {
    update: function(cart){
      const self = this;

      self.data = {
        enabled: window.odTheme.customer['promotion']['enabled'],
        displayInCart: false,
        requiredTag: window.odTheme.customer['promotion']['renewal_promotion_tag'],
        isLoggedIn: window.odTheme.customer && window.odTheme.customer.loggedIn,
      }

      if (self.data.enabled == false) {
        self.data.displayInCart = false;
        return self;
      }

      if (self.data.enabled){
        self.getRenewalProducts(cart);
        return self;
      }
    },

    getCart: async function(){
      var self = this;

      return new Promise(function(resolve, reject) {

        $.ajax({
          url: '/cart?view=json',
          success: function (data) {

            var cart = JSON.parse(data);
            
            
            return resolve(cart);

          },
          error: function (XMLHttpRequest) {
            return resolve(); 
          }
        });
        
      });

    },

    checkRequiredProduct: function(cart){
      const self = this;

      let hasRequiredProduct = false;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];

        if (item.product_tags.indexOf(self.data.requiredTag) > -1){
          hasRequiredProduct = true;
          break;
        }
      }

      return hasRequiredProduct;

    },

    getRenewalProducts: async function(cart){
      const self = this;

      cart = cart ? cart : await self.getCart();

      self.data.hasRequiredProduct = self.checkRequiredProduct(cart);
      if (self.data.hasRequiredProduct){
        self.data.displayInCart = true;
      }

    }

  });

return RenewalPromotion;

})();